import { render } from "./LevelIndicatorView.vue?vue&type=template&id=b5272626&scoped=true"
import script from "./LevelIndicatorView.vue?vue&type=script&lang=js"
export * from "./LevelIndicatorView.vue?vue&type=script&lang=js"

import "./LevelIndicatorView.vue?vue&type=style&index=0&id=b5272626&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5272626"]])

export default __exports__